module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty_man-desktop-4a685063fe2ac18b8a966d4fc83f0e8b.jpg";